export namespace DOM {
  export function byId<T extends HTMLElement>(id: string): T {
    return document.getElementById(id) as T;
  }

  export function bySelector(selector: string): HTMLElement[] {
    const matches = document.querySelectorAll(selector);
    return Array.prototype.map.call(matches, (m) => m);
  }

  export function onIdClick<T extends HTMLElement>(id: string, callback: (ev?: MouseEvent, elem?: T) => void): void {
    const elem = byId<T>(id);
    elem.addEventListener('click', ev => { callback(ev, elem); });
  }

  export function onIdChange<T extends HTMLElement>(id: string, callback: (elem?: T) => void): void {
    const elem = byId<T>(id);
    elem.addEventListener('change', () => callback(elem));
  }

  export function toElem(html: string): HTMLElement {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.children[0] as HTMLElement;
  }

  export function toggleClass(ids: string[], shouldSet: boolean, className: string): void {
    for (const id of ids) {
      const elem = byId(id);
      if (shouldSet) {
        elem.classList.add(className);
      } else {
        elem.classList.remove(className);
      }
    }
  }
}